import { render, staticRenderFns } from "./Patrol4m.vue?vue&type=template&id=45df2f68&scoped=true&"
import script from "./Patrol4m.vue?vue&type=script&lang=js&"
export * from "./Patrol4m.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45df2f68",
  null
  
)

export default component.exports